const BUSINESS_TRAVELLER_BUSINESS_INDUSTRIES_OPTIONS: Array<[App.BusinessTraveller.BusinessIndustries, string]> = [
  ['accommodation', 'Accommodation and food services'],
  ['administration', 'Administrative and support services'],
  ['agriculture', 'Agriculture, forestry and fishing'],
  ['arts', 'Arts and recreation services'],
  ['construction', 'Construction'],
  ['education', 'Education and training'],
  ['utilities', 'Electricity, gas, water and waste services'],
  ['finance', 'Financial and insurance services'],
  ['health', 'Health care and social assistance'],
  ['telecommunications', 'Information media and telecommunications'],
  ['manufacturing', 'Manufacturing'],
  ['mining', 'Mining'],
  ['science', 'Professional, scientific and technical services'],
  ['publicadmin', 'Public administration and safety'],
  ['realestate', 'Rental, hiring and real estate services'],
  ['retail', 'Retail or wholesale trade'],
  ['transport', 'Transport, postal and warehousing'],
  ['other', 'Other'],
]

export default BUSINESS_TRAVELLER_BUSINESS_INDUSTRIES_OPTIONS
